import React from 'react';

import {PageMenu} from '../components/PageMenu';

export const PrivacyPage: React.FC = () => (
  <main id="policy">
    <PageMenu active="/privacy" />

    <h1 className="mb-16 mt-20 text-center text-3xl font-light text-neutral-700">
      プライバシーポリシー
    </h1>
    <div className="mt-6 pb-20 text-left text-sm font-light text-neutral-900 [&_section>p:not(:last-child)]:mb-3.5">
      <div className="mx-auto max-w-[840px] px-4">
        <p className="mb-3.5 text-neutral-700">
          株式会社エムセック(以下「当社」とする)は、個人情報の重要性を尊重し、その保護の徹底を図るために、個人情報の保護に関して適用される法令を遵守するとともに、以下のとおりプライバシーポリシーを設定いたします。
        </p>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            1.個人情報の取り扱いについて
          </h2>
          <p>
            プライバシーポリシーは、本サイトのサービス利用時に適用されます。また個人情報はプライバシーポリシーにしたがって、「個人情報保護管理者」の責任の下、適切な管理を行うものとします。なお当社は個人情報の不正アクセス、紛失、破壊、改ざん及び漏洩などを予防するとともに、万一の場合には速やかな是正措置を行います。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            2.個人情報の収集について
          </h2>
          <p>
            当社は下記における目的を遂行する場合に、個人情報の収集を行います。個人情報の収集は、合理的に必要な範囲に限定するものとします。当社へのお客様ご自身の個人情報の提供は、お客様の任意です。お客様がご自身の個人情報の提供を希望されない場合、又新たな使用目的への使用に同意されない場合は、個人情報が不可欠なサービスはご利用頂けない事がありますのでご了承下さい
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            2-1.当社の運営するサービスをご利用頂いた場合
          </h2>
          <p>
            当社は、お客様に対し、会員登録手続きを通じて、会員の氏名及び
            Eメールアドレス（以下「会員情報」といいます。）の提供をお願いするほか、イベント主催者がそのイベントページにおいて必要に応じて作成する参加者に対するアンケートフォームを通じて、お客様から、住所、電話番号、会社名、役職その他主催者が必要と認める個人情報（以下「イベント主催者が必要とする参加者情報」といいます。）を取得します。また、有料チケットの購入やチケット販売代金の払い出しは、第三者企業が提供する決済サービスの利用を要するため、それぞれの規定に従いその他個人情報を登録する必要があります。さらに、本サイトにログインする際に第三者企業のアカウントを利用する場合は、それぞれの第三者企業のプライバシーポリシーが適用されます。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            2-2.当社にお問い合わせを頂いた場合
          </h2>
          <p>
            問い合わせにお答えする為に必要な氏名、Eメールアドレス、電話番号を含む連絡先などの個人情報の提供をお願いしております。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            2-3.当社が各種懸賞キャンペーンを実施する場合
          </h2>
          <p>
            キャンペーンの申し込みに必要な氏名、Eメールを含む連絡先などの個人情報の提供をお願いしております。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            2-4.当社が提供するメールマガジンにお申し込み頂く場合
          </h2>
          <p>
            メールマガジンをお届けする為に必要なEメールアドレスの提供をお願いしております。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            3.個人情報の使用目的
          </h2>
          <p>
            当社は、下記の目的で会員情報及びイベント主催者が必要とする参加者情報を含むお客様の個人情報を使用いたします。
          </p>
          <p>・問合せの受付と回答のために使用します。</p>
          <p>・サービスを安全かつ確実に提供するために使用します。</p>
          <p>・サービス向上のための参考資料として使用します。</p>
          <p>・会員向けサービスをより充実したものにするために使用します。</p>
          <p>
            ・特別なサービスや新しい資料などの情報をお知らせするために使用します。
          </p>
          <p>・必要に応じてお客様と連絡をするために使用します。</p>
          <p>
            ・利用状況や利用環境などに関する調査を実施するために使用します。
          </p>
          <br />
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            4.個人情報を第三者に提供する場合について
          </h2>
          <p>
            当社は、下記の場合を除いて会員情報及びイベント主催者が必要とする参加者情報を含むお客様の個人情報を、第三者に提供することはありません。
          </p>
          <p>・会員本人の同意がある場合。</p>
          <p>・法令に基づく場合</p>
          <p>
            ・人の生命、身体又は財産の保護のために必要である場合であって、会員本人の同意を得ることが困難であるとき
          </p>
          <p>
            ・公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
          </p>
          <p>
            ・国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき。
          </p>
          <br />
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            5.個人情報の取扱いの委託を行う場合について
          </h2>
          <p>
            当社は、上記の使用目的の達成に必要な範囲内において、イベント主催者に対し、以下のいずれかの目的で、当社で保有する会員情報及びイベント主催者が必要とする参加者情報を含むお客様の個人情報を、当該イベント主催者又は当社との間で共同開発契約、事業提携契約その他当社のサービスに関して協業することを内容とする契約を締結した第三者（以下「協業先となる第三者」といいます。）に提供し、これをイベント主催者又は協業先となる第三者と共同して利用することがあります。
          </p>
          <p>
            ・イベント主催者において、その開催するイベントにおける参加者を管理すること。
          </p>
          <p>
            ・イベント主催者において、その開催するイベントに参加する予定の又は参加した会員に対し、連絡をとること。
          </p>
          <p>
            ・当社と協業先となる第三者の協業により、当社のサービスを安全かつ確実に提供すること。
          </p>
          <p>
            ・当社と協業先となる第三者の協業により、会員向けサービスをより充実したものにすること。
          </p>
          <p>
            ・当社と協業先となる第三者の協業により、特別なサービスや新しいサービスを提供すること。
          </p>
          <br />
          <p>
            なお、この共同利用に際してイベント主催者又は協業先となる第三者に対し提供される個人情報の管理については、当社及び当該イベント主催者又は当該協業先となる第三者になります。法令及び当社の基準に従って委託先を選定し、機密保持契約を締結します。委託先に対しては個人情報の適切な取扱いを監督指導します。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            6.広告・情報配信サービスに関連するクッキーについて
          </h2>
          <p>
            当社はクッキー技術を利用したデータ解析による様々な広告配信、情報配信サービスの最適化を実施しています。なお、このクッキーには、ユーザー個人を特定・識別する情報は一切含まれず、クッキーによって取得されるサイト上行動履歴情報は、本サービスの提供やマーケティング活動に利用する目的のみに使用され、その他の目的には使用されません。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            7.ダイレクトメール
          </h2>
          <p>
            利用規約に同意頂いた方には有益と思われる情報をご登録いただいた
            Eメールアドレスにお送りします。なお、ダイレクトメールを拒否することも可能です。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            8.個人情報の開示等の請求について
          </h2>
          <p>
            当社は、保有する会員情報及びイベント主催者が必要とする参加者情報を含むお客様の個人情報に関する「使用目的の通知」「開示」「訂正、追加又は削除」「利用の停止、消去又は第三者への提供の停止」(以下「開示等」という)の請求に応じています。開示等を請求される場合は、当社「個人情報窓口」までお申し出ください。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            9.セキュリティについて
          </h2>
          <p>
            お客様の個人情報は、プライバシー保護およびセキュリティのためパスワードで保護されています。また、お客様の情報が送信される際のセキュリティのために、SSL
            (Secure Socket
            Layer)を使って、入力される情報を暗号化するなど個人情報の消失、変更、毀損などを防ぐために技術対策をしております。但し、一般的にインターネット経由のデータ送信は
            100％安全とはいい切れません。本サイトでは会員の個人情報保護のために最善を尽くしておりますが、本サイトのサービスとして提供される情報のセキュリティ全てを確実に保証することはできかねます点ご了承ください。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            10.免責
          </h2>
          <p>
            以下の場合には、当社にご提供いただいたお客様の個人情報を、上記「4.
            個人情報を第三者に提供する場合について」に規定される事由以外の事由によって第三者が取得したことに関し、当社は何らの責任を負いません。
          </p>
          <p>
            ・会員が本サイトのサービス機能を用いて第三者に個人情報を明かした場合
          </p>
          <p>
            ・会員が本サイトのサービス上に入力した情報等により、個人が識別できてしまった場合
          </p>
          <p>・個人情報を含むコンテンツをアップロードした場合</p>
          <p>
            ・イベント主催者又は協業先となる第三者が個人情報取扱事業者に該当する場合において、それぞれが個人情報取扱事業者として遵守すべき義務遵守を怠った場合
          </p>
          <p>
            ・前項に定めるほか、上記「4.
            個人情報を第三者に提供する場合について」に規定されるところに従って当社からお客様の個人情報の開示又は提供を受けた第三者が、その故意又は過失により、当該第三者が保有するお客様の個人情報を違法に開示し、又は漏えいさせた場合
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            11.プライバシーポリシーの改定について
          </h2>
          <p>
            当社は本プライバシーポリシーについて適時見直しを行い改定する事があります。重要な変更がある場合にはサイトにてお知らせします。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            12. その他ご留意いただきたい点について
          </h2>
          <p>
            本ページ記載事項は、当社、会員との間において効力を持つものであり、本ページのリンク先を含む第三者に適用されるものではありません。
          </p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            13.個人情報に関するお問合せ先
          </h2>
          <p>〒723-0014 広島県三原市城町一丁目 12-5 エムセックビル</p>
          <p>株式会社エムセック「個人情報窓口」</p>
          <p>TEL:0848-63-5584</p>
          <p>
            <a className="text-primary" href="/contact">
              お問い合わせフォーム
            </a>
          </p>
        </section>

        <section className="mb-10">
          <p>平成30年4月1日 制定</p>
          <p>令和3年1月12日 改定</p>
        </section>

        <section className="mb-10">
          <p>【事業者及び個人情報保護管理者】</p>
          <p>株式会社エムセック</p>
          <p>
            代表取締役社長{'　'}小畠{'　'}祐輝
          </p>
          <p>TEL:0848-63-5584</p>
        </section>
      </div>
    </div>
  </main>
);
